import { Button, Icon, Styles } from "@/shared/coralreef";
import { faHome, faQuestion } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "@tanstack/react-router";
import { important, percent, px, rem, viewHeight } from "csx";
import { Content, Horizontal, Stretch, Vertical } from "gls";
import { useTranslation } from "react-i18next";
import { style } from "typestyle";

export const NotFoundPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stretch
      width={percent(100)}
      padding={[viewHeight(20), 0, 0, 0]}
      horizontalAlign="center"
      className={style({
        color: Styles.Colours.textLight,
      })}
    >
      <Icon
        icon={faQuestion}
        className={style({
          width: important(rem(8)),
          height: important(rem(8)),
        })}
      />
      <div className="text-xl pb-5">{t("Page Not Found")}</div>
      <Vertical
        horizontalAlign="center"
        spacing={rem(1)}
        className={style({
          color: Styles.Colours.textLight,
        })}
      >
        <Content>{t("The page you are looking for doesn't exist")}</Content>
        <Content>
          {t("Please check the URL or try navigating to another page")}
        </Content>
        <Horizontal width={percent(100)} verticalAlign="center">
          <Divider />
          <Content
            className={style({
              color: Styles.Colours.textDisabled,
            })}
          >
            {t("or")}
          </Content>
          <Divider />
        </Horizontal>

        <Button
          content={t("Go to Home")}
          icon={faHome}
          appearance="hollow"
          onClick={() => navigate({ to: "/" })}
        />
      </Vertical>
    </Stretch>
  );
};

const Divider = () => (
  <Stretch
    className={style({
      height: px(1),
      background: Styles.Colours.textDisabled,
    })}
  />
);

export default NotFoundPage;
